export default __webpack_public_path__ + "static/media/doctor.764c9b43.PNG";